export enum JacquardMachineLoomLayoutZoneRepeatType {
  NONE,
  INLINE,
  MIRROR
}
